<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gxev29/tc-custom/9781504050265.jpg?1734280285230" alt="This image is the cover for the book Eight Faces at Three, The John J. Malone Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Eight Faces at Three, The John J. Malone Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>“The grand dame of mystery mixed with screwball comedy” introduces her popular, sharp-witted Chicago lawyer/sleuth (Ed Gorman, Ellery Queen Award–winning author).</b><br/>  <br/> John J. Malone, defender of the guilty, is notorious for getting his culpable clients off. It’s the innocent ones who are problems. Like Holly Inglehart, accused of piercing the black heart of her well-heeled and tyrannical aunt Alexandria with a lovely Florentine paper cutter. No one who knew the old battle-ax liked her, but Holly’s prints were found on the murder weapon. Plus, she had a motive: She was about to be disinherited for marrying a common bandleader.<br/>  <br/> With each new lurid headline, Holly’s friends and supporters start to rally. There’s North Shore debutante Helene Brand; Holly’s groom’s press agent, Jake Justus; the madam of a local brothel, and Alexandria’s hand-wringing servants. But not one of them can explain the queerest bent to the crime: At the time of the murder, every clock in the Inglehart mansion stopped dead. And that’s only the first twist in a baffling case of “aunty-cide”—because Alexandria won’t be the last to die.<br/>  <br/> Making his debut in this fun and funny novel, Craig Rice’s one-of-a-kind Chicago attorney is “an inspired creation . . . an unapologetic champion of the defense bar . . . a defender of the guilty whose contempt for society outstrips his contempt for criminals” (Jon L. Breen, Edgar Award–winning author).<br/>  <br/> Eight Faces at Three <i>is the 1st book in the John J. Malone Mysteries, but you may enjoy reading the series in any order.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Craig Rice
      </h2>
      
      <p class="authorDescription body article">Craig Rice (1908&ndash;1957), born Georgiana Ann Randolph Craig, was an American author of mystery novels and short stories described as &ldquo;the Dorothy Parker of detective fiction.&rdquo; In 1946, she became the first mystery writer to appear on the cover of <I>Time </I>magazine. Best known for her character John J. Malone, a rumpled Chicago lawyer, Rice&rsquo;s writing style was both gritty and humorous. She also collaborated with mystery writer Stuart Palmer on screenplays and short stories, as well as with Ed McBain on the novel <I>The April Robin Murders</I>.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      MysteriousPress.com/Open Road
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?197149e8